import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ArticlesPage.css";
import LoadBalancingArticle from "../../components/Articles/LoadBalancingArticle";
import DatabaseShardingArticle from "../../components/Articles/DatabaseShardingArticle";

interface Article {
  id: string;
  title: string;
  component: React.ReactNode;
}

interface ArticlesPageProps {
  theme: "light" | "dark";
  toggleTheme: () => void;
}

const ArticlesPage: React.FC<ArticlesPageProps> = ({ theme, toggleTheme }) => {
  const navigate = useNavigate();
  const [selectedArticleId, setSelectedArticleId] =
    useState<string>("load-balancing");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);

  const articles: Article[] = [
    {
      id: "load-balancing",
      title: "Load Balancing Strategies",
      component: <LoadBalancingArticle />,
    },
    {
      id: "database-sharding",
      title: "Database Sharding",
      component: <DatabaseShardingArticle />,
    },
  ];

  const filteredArticles = articles.filter((article) =>
    article.title.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const selectedArticle = articles.find(
    (article) => article.id === selectedArticleId,
  );

  return (
    <div className="articles-page">
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <button
              className="menu-toggle"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
              ☰
            </button>
            <h1 className="logo" onClick={() => navigate("/")}>
              System Design Hub
            </h1>
          </div>
          <button className="theme-toggle" onClick={toggleTheme}>
            {theme === "light" ? "🌙" : "☀️"}
          </button>
        </div>
      </header>

      <div className="content-wrapper">
        <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <div className="search-container">
            <input
              type="text"
              className="search-input"
              placeholder="Search articles..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <nav className="nav-list">
            <h3 className="nav-title">Articles</h3>
            {filteredArticles.length > 0 ? (
              filteredArticles.map((article) => (
                <button
                  key={article.id}
                  className={`nav-item ${selectedArticleId === article.id ? "active" : ""}`}
                  onClick={() => {
                    setSelectedArticleId(article.id);
                    setIsSidebarOpen(false);
                  }}
                >
                  {article.title}
                </button>
              ))
            ) : (
              <p className="no-results">No articles found</p>
            )}
          </nav>
        </aside>

        <main className="main-content">
          <div className="article-container">{selectedArticle?.component}</div>
        </main>
      </div>

      {isSidebarOpen && (
        <div className="overlay" onClick={() => setIsSidebarOpen(false)} />
      )}
    </div>
  );
};

export default ArticlesPage;
